import { TelemetryClientId } from '@ms/yammer-telemetry-support';
import { MetaOsHubName } from '@ms/yammer-web-support/dist/metaOsHub';
import { isInVivaConnectionsApp } from 'vivaConnections';

import { VivaEngageAppEntityId, getContext } from '../../teams/context';

export enum TelemetryClientIdType {
  YammerTeams = 'YAMMER_TEAMS',
  YammerMetaOsOutlookPersonalApp = 'YAMMER_METAOS_OUTLOOK_PERSONAL_APP',
  YammerMetaOsOfficePersonalApp = 'YAMMER_METAOS_OFFICE_PERSONAL_APP',
  YammerVivaConnections = 'YAMMER_VIVA_CONNECTIONS',
  YammerVivaEngagePersonalApp = 'YAMMER_VIVAENGAGE_PERSONAL_APP',
  YammerVivaEngageOutlookPersonalApp = 'YAMMER_VIVAENGAGE_OUTLOOK_PERSONAL_APP',
  YammerVivaEngageOfficePersonalApp = 'YAMMER_VIVAENGAGE_OFFICE_PERSONAL_APP',
}

type GetTelemetryClientId = () => Promise<TelemetryClientId>;
export const getTelemetryClientId: GetTelemetryClientId = async () => {
  if (isInVivaConnectionsApp()) {
    return TelemetryClientIdType.YammerVivaConnections;
  }

  try {
    const { appType, hubName, entityId } = await getContext();

    const isVivaEngageApp = entityId === VivaEngageAppEntityId;

    if (isVivaEngageApp) {
      if (hubName === MetaOsHubName.Outlook) {
        return TelemetryClientIdType.YammerVivaEngageOutlookPersonalApp;
      }

      if (hubName === MetaOsHubName.Office) {
        return TelemetryClientIdType.YammerVivaEngageOfficePersonalApp;
      }

      return TelemetryClientIdType.YammerVivaEngagePersonalApp;
    }

    if (hubName === MetaOsHubName.Outlook) {
      return TelemetryClientIdType.YammerMetaOsOutlookPersonalApp;
    }

    if (hubName === MetaOsHubName.Office) {
      return TelemetryClientIdType.YammerMetaOsOfficePersonalApp;
    }

    if (appType === 'tab') {
      return TelemetryClientIdType.YammerTeams;
    }

    return TelemetryClientIdType.YammerVivaEngagePersonalApp;
  } catch {
    //continue regardless of error
  }

  return TelemetryClientIdType.YammerVivaEngagePersonalApp;
};
